import { render, staticRenderFns } from "./BorrowHistory.vue?vue&type=template&id=19859ba7&scoped=true&"
import script from "./BorrowHistory.vue?vue&type=script&lang=js&"
export * from "./BorrowHistory.vue?vue&type=script&lang=js&"
import style0 from "./BorrowHistory.vue?vue&type=style&index=0&id=19859ba7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19859ba7",
  null
  
)

export default component.exports